import { Inject, Injectable } from "@angular/core";
import saveAs from 'file-saver';
import { Platform } from "ionic-angular";
import { Observable } from "rxjs";
import { EventNameAnalytics } from "../../helpers/event-name-analytics";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { FileDownloaderProvider } from "../../providers/file-downloader/file-downloader";
import { RequestPersonalReportDto } from "../../shared/nestjs/gd-only/dto/personal-report.dto";
import { PersonalReportApi } from "../../shared/nestjs/gd-only/services/personal-report.api";
import { NestApiProvider } from "../../shared/nestjs/nest-api";
import { LoopBackAuth } from "../../shared/sdk";

@Injectable()
export class PersonalReportBloc {
  isGoPathNew: Boolean;
  // loading: any;

  constructor(
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    private nestApiProvider: NestApiProvider,
    private platform: Platform,
    private fileDownloaderProvider: FileDownloaderProvider,
    private personalReportApi: PersonalReportApi,
    private analyticsProvider: AnalyticsProvider
  ) {
  }

  downloadExcel(data: RequestPersonalReportDto): Observable<any> {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
    return this.personalReportApi.downloadExcel(data)
  }

  generateExcel(data) {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadExcelBlob(data, 'Personal Report')
    } else {
      saveAs(data, 'Personal Report.xlsx')
    }
  }

  downloadPdf(data: RequestPersonalReportDto): Observable<any> {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
    return this.personalReportApi.downloadPdf(data)
  }

  generatePdf(data) {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadPdfBlob(data, 'Personal Report')
    } else {
      saveAs(data, 'Personal Report.pdf')
    }
  }

  sendExcel(data):Observable<any> {
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);

        if (isGoPathNewExist) {
          let dataNest: RequestPersonalReportDto = {
            empIds: data.empIds
          }
          return this.personalReportApi.reportSendEmailExcel(dataNest)
        }
      })
  }

  sendPdf(data):Observable<any>{
    return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
      .mergeMap(isGoPathNewExist => {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);

        if (isGoPathNewExist) {
          let dataNest: RequestPersonalReportDto = {
            empIds: data.empIds
          }
          return this.personalReportApi.reportSendEmailPdf(dataNest)
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/bloc/report/personal-report.bloc.ts